import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  button: {
    fontSize: theme.typography.fontSize - 3,
  },
}));
